
document.addEventListener("DOMContentLoaded", async () => {
  const container = document.getElementById("custom-collection-grid");
  if (!container) return;

  const params = new URLSearchParams(window.location.search);
  const productCollection = params.get("product");
  const designCollection = params.get("design");
  const returnBtnContainer = document.getElementById("return-button-container");

  const productsOnlyBlack = [
    "Unisex Tri-Blend T-Shirt",
    "Unisex Oversized Hoodie",
    "Unisex Premium Heavyweight Long Sleeve Shirt",
    "Eco Tote Bag",
    "Large Eco Tote Bag",
    "Snapback Trucker Cap",
    "Closed-Back Trucker Cap",
    "Vintage Corduroy Cap",
    "Vintage Cap",
    "Organic Baseball Cap",
    "Denim Hat",
    "Denim Bucket Hat",
    "Corduroy Hat",
    "5 Panel Cap",
    "Distressed Denim Bucket Hat"
  ].map(p => p.toLowerCase());

  const productsOnlyWhite = [
    "Unstructured Terry Cloth Bucket Hat"
  ].map(p => p.toLowerCase());

  const renderReturnLink = (toGallery = false) => {
    if (!returnBtnContainer) return;
    const href = toGallery ? '/pages/gallery' : `/collections/${designCollection}`;
    const label = toGallery ? '← Return to Designs page' : `← Return to ${designCollection}`;
    returnBtnContainer.innerHTML = `
      <div class="px-section md:px-section-desktop mb-4">
        <a href="${href}" class="text-sm underline transition" style="color: white;" onmouseover="this.style.color='#c4ff00'" onmouseout="this.style.color='white'">
          ${label}
        </a>
      </div>
    `;
  };

  if (!productCollection || !designCollection) {
    renderReturnLink(true);
    return;
  }

  try {
    const designRes = await fetch(`/collections/${designCollection}/products.json?limit=250`);
    const designData = await designRes.json();
    const handlesInDesign = new Set(designData.products.map(p => p.handle));

    renderReturnLink();

    const titleElement = document.createElement("h2");

const isSloganCollection = designCollection
  ?.toLowerCase()
  .includes("slogan");

titleElement.textContent = isSloganCollection
  ? "Select a product then you can change the design"
  : "Select a product then you can change the embroidery design";

titleElement.className = "text-center text-xl font-semibold mb-6 text-white";
container.before(titleElement);

    // Toggle Button
    const toggleWrapper = document.createElement("div");
    toggleWrapper.className = "text-center mb-6";

    const toggleButton = document.createElement("button");
    toggleButton.textContent = "Switch to White Only";
toggleButton.className = "border rounded text-white border-white hover:bg-white hover:text-black transition tracking-widest text-sm";
toggleButton.style.padding = "12px 32px"; // top/bottom 12px, left/right 32px
toggleButton.style.margin = "0 auto"; // si tu veux centrer
    toggleWrapper.appendChild(toggleButton);

    let whiteOnly = false;
    toggleButton.addEventListener("click", () => {
      whiteOnly = !whiteOnly;
      toggleButton.textContent = whiteOnly ? "Show All Colors" : "Switch to White Only";
      renderProductList(whiteOnly);
    });

    container.before(toggleWrapper);

    container.innerHTML = `
      <ul class="product-list grid grid-cols-2 gap-5 md:grid-cols-3 md:gap-grid-gutter px-section md:px-section-desktop"></ul>
    `;
    const list = container.querySelector("ul");

    // Fetch All Products First
    let allMatchingProducts = [];

    const fetchAllProducts = async () => {
      let page = 1;
      let hasMore = true;

      while (hasMore) {
        const res = await fetch(`/collections/${productCollection}/products.json?limit=250&page=${page}`);
        const data = await res.json();
        const matching = data.products.filter(p => handlesInDesign.has(p.handle));
        allMatchingProducts.push(...matching);
        hasMore = data.products.length === 250;
        page++;
      }
    };

    const renderProductList = (filterWhiteOnly = false) => {
      list.innerHTML = '';
      let foundCount = 0;

      for (const product of allMatchingProducts) {
        const title = product.title;
        const lowerTitle = title.toLowerCase();
        const baseName = title.split(" - ")[0].trim().toLowerCase();
        if (/btc\s*\(noir\)/i.test(title)) continue;

        const isOnlyWhite = productsOnlyWhite.includes(baseName);
        const isOnlyBlack = productsOnlyBlack.includes(baseName);

        // FILTRES
        if (lowerTitle.includes("green")) continue;
        if (filterWhiteOnly && !lowerTitle.includes("white") && !isOnlyWhite) continue;
        if (!filterWhiteOnly && lowerTitle.includes("white") && baseName !== "unstructured terry cloth bucket hat" && baseName !== "organic bucket hat") continue;

        const image = product.images[0]?.src || "";
        const price = product.variants[0].price;
        const url = `/products/${product.handle}`;

        let colorSwatchesTop = '';
        if (!isOnlyWhite) {
          colorSwatchesTop += `<span class="inline-block w-4 h-4 rounded-full border border-gray-400" style="background-color: black;"></span>`;
        }
        if (!isOnlyBlack) {
          colorSwatchesTop += `<span class="inline-block w-4 h-4 rounded-full border border-gray-400 ml-1" style="background-color: white;"></span>`;
        }

        let colorSwatchesBottom = '';
        if (lowerTitle.includes("blue")) {
          colorSwatchesBottom += `<span class="inline-block w-4 h-4 rounded-full border border-gray-400" style="background-color: #357cc6;"></span>`;
          colorSwatchesBottom += `<span class="inline-block w-4 h-4 rounded-full border border-gray-400 ml-1" style="background-color: #267251;"></span>`;
        }

        const itemHTML = `
          <li class="product-list-item">
            <div class="product-card group relative" data-product-card>
              <a href="${url}" class="block">
                <div class="relative overflow-hidden">
                  <div class="aspect-w-1 aspect-h-1 z-0" data-scale-reveal data-zoom-on-hover>
                    <img src="${image}" alt="${title}" class="object-cover w-full h-full transition-transform duration-300 ease-in-out" loading="lazy" />
                  </div>
                </div>
                <div class="mt-2 text-sm text-scheme-text">
                  <div class="font-medium">${title}</div>
                  <div class="opacity-60">${price} ${Shopify.currency.active}</div>
                  <div class="mt-1 flex items-center">${colorSwatchesTop}</div>
                  ${colorSwatchesBottom ? `<div class="mt-1 flex items-center">${colorSwatchesBottom}</div>` : ''}
                </div>
              </a>
            </div>
          </li>
        `;
        list.insertAdjacentHTML("beforeend", itemHTML);
        foundCount++;
      }

      if (foundCount === 0) {
        container.innerHTML = `<p class='text-center mb-4'>No product found.</p>`;
        renderReturnLink(true);
      }
    };

    await fetchAllProducts();
    renderProductList();

  } catch (err) {
    console.error("Error loading products:", err);
    container.innerHTML = "<p class='text-center'>Error loading products.</p>";
    renderReturnLink(true);
  }
});

